import { AUTHOR_CREATE_GQL, AUTHOR_DELETE_GQL, AUTHOR_UPDATE_GQL } from './gql';
import { apolloClient } from '../client';
import { AuthorInput } from './author.types';
import { Author } from '../types.generated';

export const createAuthorMutation = async (payload: Omit<AuthorInput, 'id'>): Promise<Author | undefined> => {
  const response = await apolloClient.mutate<{ createAuthor: Author }>({
    mutation: AUTHOR_CREATE_GQL,
    variables: {
      input: payload,
    },
  });

  return response.data?.createAuthor;
};

export const updateAuthorMutation = async (payload: AuthorInput): Promise<Author | undefined> => {
  const { id, ...restData } = payload;

  const response = await apolloClient.mutate<{ updateAuthor: Author }>({
    mutation: AUTHOR_UPDATE_GQL,
    variables: {
      id,
      input: restData,
    },
  });

  return response.data?.updateAuthor;
};

export const deleteAuthorMutation = async (id: Author['id']): Promise<Author['id'] | undefined> => {
  const response = await apolloClient.mutate<{ deleteAuthor: Author['id'] }>({
    mutation: AUTHOR_DELETE_GQL,
    variables: {
      id,
    },
  });

  return response.data?.deleteAuthor;
};
